import { apiClient } from '@/shared/api/client';
import { API_ENDPOINTS } from '@/shared/constants/api/endpoints.ts';
import type {
  DesktopAuthorizeDecision,
  DesktopAuthorizeParams,
  DesktopAuthorizePreview,
  DesktopAuthorizeResult,
} from '../types/desktop-auth.type';

export const desktopAuthApi = {
  /** 동의 화면 진입 시 요청 검증 + 표시 정보. */
  preview: (params: DesktopAuthorizeParams) =>
    apiClient
      .get<DesktopAuthorizePreview>(API_ENDPOINTS.auth.desktopAuthorize, {
        params: {
          clientId: params.clientId,
          redirectUri: params.redirectUri,
          codeChallenge: params.codeChallenge,
          codeChallengeMethod: params.codeChallengeMethod,
          deviceLabel: params.deviceLabel,
          deviceHint: params.deviceHint,
        },
      })
      .then((r) => r.data),

  /** 허용·거절 모두 서버가 루프백 URL 을 만들어 준다. 별명은 새 PC 허용일 때만 싣는다. */
  decide: (
    params: DesktopAuthorizeParams,
    decision: DesktopAuthorizeDecision,
    deviceNickname?: string,
  ) =>
    apiClient
      .post<DesktopAuthorizeResult>(API_ENDPOINTS.auth.desktopAuthorize, {
        ...params,
        decision,
        ...(deviceNickname ? { deviceNickname } : {}),
      })
      .then((r) => r.data),
};
